document.addEventListener("DOMContentLoaded", function () {
  // ===== 全局逻辑：记录 return url =====
  const fullUrl = window.location.href;

  // 解析URL查询参数
  const urlObj = new URL(fullUrl);
  const params = new URLSearchParams(urlObj.search);

  // 检查是否包含from=official参数
  if (params.has("from") && params.get("from") === "official") {
    // 收集所有查询参数
    const officialInfo = {
      official: true,
      timestamp: Date.now(),
    };

    // 将所有URL参数存储到对象中
    for (const [key, value] of params.entries()) {
      officialInfo[key] = value;
    }

    localStorage.setItem(
      "yg_official_info",
      JSON.stringify(officialInfo)
    );

    console.log("存储YG官方信息:", officialInfo);
  }
});